import React from 'react'
import Card from '../../components/card'
import { withRouter } from 'react-router-dom'
import { AuthContext } from '../../main/authProvider'

import { Button } from 'primereact/button'
import ConstantsUtil from '../../context/constantsUtil'
import TransactionService from '../../app/service/estoque/transactionService'
import FormGroup from '../../components/form-group'
import SelectMenu from '../../components/selectMenu'
import * as popUp from '../../components/toastr'
import GeneralServices from '../../app/service/generalServices'
import DateIntervalCalendar from '../../components/calendar/dateIntervalCalendar'
import NFseTable from '../../components/nfse/nfseTable'
import DialogFooter from '../../components/dialogFooter'
import { Dialog } from 'primereact/dialog'
// import HandleErrorService from '../../app/service/handleErrorService'

class ConferenciaNfse extends React.Component {

        constructor(){
        super();
        this.transactionService = new TransactionService();
        this.generalServices = new GeneralServices();
    }

    state = {
        habilitaBusca: true,

        selectedFiltrarPor: '',
        inputNFFilterTypeErrorClass: '',

        initialDate: '',
        initialDateView: '',
        finalDate: '',
        finalDateView: '',

        selectedFilterType: '',
        missingFilterType: false,
        missingAnyDate: false,

        tipoNF: '',
        errorTypeMessage: null,
        inputTypeErrorClass: null,

        isSearchByNumero: false,
        numeroNFToSearch: '',
        inputSearchNumeroErrorClass: '',


    }

    handleChange = async (event) => {
        const value = event.target.value
        const name = event.target.name
        await this.setState({ [name]: value })
    }

    handleFiltrarPorChange = async (event) => {
        const value = event.target.value
        const name = event.target.name
        await this.setState({ [name]: value })
        if(value === ConstantsUtil.filtroDataEntradaLabel){
            popUp.infoPopUp(`Ao filtrar por Data de Entrada, apenas as notas "Validadas" serão listadas.<br/>
                Para ver as notas "Excluídas" após a validação (se houver), altere o filtro "Situação" na tabela que será gerada abaixo
                e clique no botão "Filtrar".
            `)
        }

        if(value){
            var select = document.getElementById(ConstantsUtil.componenteEscolherPeriodoId)
            select.focus();
        }

        if(value === ConstantsUtil.filtroDataEntradaLabel){
            let tipoNotaFiscalEvent = {target: {name: 'tipoNF', value: ConstantsUtil.entradaLabel}}
            this.handleChange(tipoNotaFiscalEvent)
        }

    }

    handleDateFilterChange = (selectedFilterType) => {
        this.setState({selectedFilterType})
    }

    handleDateChange = async (initialDate, finalDate) => {
        await this.setState({initialDate})
        
        await this.setState({initialDateView: GeneralServices.convertBrStringToJsDate(initialDate)})

        await this.setState({finalDate})
        await this.setState({finalDateView: GeneralServices.convertBrStringToJsDate(finalDate)})

    }     


    resetView = async () => {

        this.setState({inputNFFilterTypeErrorClass: ''})

        // console.log("this.state.tipoNF: ", this.state.tipoNF)

        if(this.state.tipoNF) {
            this.setState({inputTypeErrorClass: ""})
            this.setState({errorTypeMessage:""})
        }

        this.setState({missingFilterType: false})
        this.setState({missingAnyDate: false})

    }

    toggleButton = () => {
        if(!this.state.habilitaBusca && this.state.isSearchByNumero){
            this.setState({isSearchByNumero: false})
            this.setState({numeroNFToSearch: ''})
        }
        this.setState({habilitaBusca: !this.state.habilitaBusca})
    }

    buscarButtonClick = async () => {
        this.callSearch()
    }

    callSearch = () => {
        this.resetView()
        if(this.checkData()){
            this.setState({habilitaBusca: false})
        }
    }

    checkData = () => {
        var check = true

        if(!this.state.selectedFiltrarPor){
            this.setState({inputNFFilterTypeErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }
        
        if(!this.state.tipoNF){
            this.setState({inputTypeErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            this.setState({errorTypeMessage:"Selecione o tipo da Nota Fiscal"})
            check = false
        }
        // if(!this.state.situacao){
        //     this.setState({inputSituationErrorClass:  ConstantsUtil.bootstrapInputErrorClass})
        //     this.setState({errorSituationMessage:"Selecione a situação"})
        //     check = false
        // }

        if(!this.state.selectedFilterType){
            this.setState({missingFilterType: true})
            check=false
        }
        
        if(!this.state.initialDate || !this.state.finalDate){
            this.setState({missingAnyDate: true})
            check=false
        }

        if(this.state.initialDate && this.state.finalDate){
            if(this.state.initialDateView > this.state.finalDateView){
                check = false
                popUp.infoPopUp(ConstantsUtil.dataInicialAnteriorFinalMessage)
           }
        }        

        return check
    }

    constroiFiltro = () => {
        let filtro = {
            filtroTipoData: this.state.selectedFiltrarPor,
            dataInicial: this.state.initialDate,
            dataFinal: this.state.finalDate,
            tipoNF: this.state.tipoNF
        }
        // console.log("constroiFiltro: ", filtro)
        return filtro
    }

    searchByNumero = () => {
        this.setState({pesquisaNumeroDialogVisible: true})
    }

    hidePesquisaNumeroDialog = () => {
        this.setState({pesquisaNumeroDialogVisible: false})
        this.setState({inputSearchNumeroErrorClass: ''})
        // this.setState({numeroNFToSearch: ''})
    }

    handlePesquisaNumeroKeyPress = async (e) => {
        if (e.key === "Enter") {
            this.callSearchPesquisaNumero()
          }
    }

    callSearchPesquisaNumero = () => {
        this.setState({inputSearchNumeroErrorClass: ''})
        if(this.checkPesquisaNumeroData()){
            this.searchPesquisaByNumero()
        }
    }

    checkPesquisaNumeroData = () => {
        let check = true
        if(!this.state.numeroNFToSearch){
            check = false
            this.setState({inputSearchNumeroErrorClass: ConstantsUtil.bootstrapInputErrorClass})
        }

        return check
    }

    handleNumeroChange = async (event) => {
        let value = event.target.value
        const name = event.target.name

        if(value && value < 0){
            value*=-1
        }

        this.setState({[name]: value})
    }

    searchPesquisaByNumero = async () => {
        await this.setState({isSearchByNumero: true})
        this.setState({habilitaBusca: false})
        this.hidePesquisaNumeroDialog()
    }

    render(){

        const renderPesquisaNumeroDialog = () => {
            return (
                <Dialog
                    visible={this.state.pesquisaNumeroDialogVisible}
                    header={"Pesquisar Por Número"}
                    modal = {true}
                    style={{ width: '350px' }}
                    footer={dialogFooter}
                    onHide={this.hidePesquisaNumeroDialog}
                >
                    <div className="p-field">
                        {renderValueInput(true)}                     
                    </div>
                </Dialog>
            )
        }

        const renderValueInput = () => {
            return (
                <>
                <div className="row">
                <div className="col-md-8">
                <label htmlFor="numeroNF">Número da Nota Fiscal</label>
                <input
                    type="number"
                    className={"form-control " + this.state.inputSearchNumeroErrorClass}
                    autoFocus
                    value = {this.state.numeroNFToSearch}
                    name="numeroNFToSearch"
                    onChange={this.handleNumeroChange}
                    onKeyPress={this.handlePesquisaNumeroKeyPress}
                    id="numeroNFToSearch"
                />
                <div className="invalid-feedback">Preencha</div>                
                </div>
                </div>
                <div className="row">
                <div className="col-md-12">
                <small id="valorError" className="p-error">{this.state.errorSearchValueMessage}</small>
                </div>
                </div>
                </>
            )
        }

        const dialogFooter = (
            <DialogFooter save = {this.callSearchPesquisaNumero} hideDialog = {this.hidePesquisaNumeroDialog}/>
        )


        const renderButtons = () => {
            if(this.state.habilitaBusca){
                return (
                <div>
                    <Button 
                        className='small-button'
                        label="Buscar"
                        icon="pi pi-search"
                        onClick = {this.buscarButtonClick}
                    />
                </div>
                )
            }
            return (
                <>
                <div>
                    <Button 
                        className="small-button p-button-danger"
                        label="Voltar"
                        icon="pi pi-undo"
                        onClick = {() => {
                            this.setState({filterNFTableState: {}})
                            this.toggleButton()
                        }}
                    />
                </div>
                </>
            )            
        }

        const renderTable = () => {
            if(!this.state.habilitaBusca){
                return (
                    <NFseTable
                        filtro={this.constroiFiltro()}
                        conferenciaNF
                        isSearchByNumero={this.state.isSearchByNumero}
                        numeroNFToSearch={this.state.numeroNFToSearch}
                    />
                )
            }
        }

        const renderPesquisaPorNumeroButton = () => {
            return (
            <Button 
                label="Pesquisar Por Número"
                icon="pi pi-search"
                tooltip="Na pesquisa por número, não é necessário preencher nenhum filtro de data ou Tipo da NF."
                tooltipOptions={{position: 'left'}}                
                onClick = {this.searchByNumero}
                disabled={!this.state.habilitaBusca}
            />
            )
        }

        const renderDefaultHeaderFilter = () => {
            if(!this.state.isSearchByNumero){
                return (
                    <div className="row">

                        <div className = "col-md-2">
                            <label htmlFor="filtro">Filtrar Por</label>
                            <SelectMenu
                                className={"form-control " + this.state.inputNFFilterTypeErrorClass }
                                name="selectedFiltrarPor"
                                list= {ConstantsUtil.filtroDataNFOptionsList} 
                                value={this.state.selectedFiltrarPor}
                                onChange={this.handleFiltrarPorChange}
                                disabled={!this.state.habilitaBusca}
                            />
                            <div className="invalid-feedback">{ConstantsUtil.preecnhaLabel}</div>
                        </div>                        
    
                        <DateIntervalCalendar
                            htmlFor="SelectDatePeriod"
                            label="Escolher período"
                            handleFilterChange={this.handleDateFilterChange}
                            handleDateChange={this.handleDateChange}
                            missingFilterType={this.state.missingFilterType}
                            missingAnyDate={this.state.missingAnyDate}
                            disabled={!this.state.habilitaBusca}
                            // tooltip={"O período selecionado neste filtro será em relação à Data de Emissão da Nota Fiscal. \n Caso queira filtrar por outras datas (como entrada ou importação), utilize os filtros da tabela que será gerada abaixo."}
                        />
    
                        <div className = "col-md-2">
                        <FormGroup label = "Tipo da Nota Fiscal" htmlFor = "InputType">
                            <SelectMenu
                                className={"form-control " + this.state.inputTypeErrorClass}
                                name="tipoNF"
                                list= {this.transactionService.getTypeList()}
                                value={this.state.tipoNF}
                                onChange={this.handleChange}
                                disabled={!this.state.habilitaBusca || this.state.selectedFiltrarPor === ConstantsUtil.filtroDataEntradaLabel}
                                />
                            <div className="invalid-feedback">{this.state.errorTypeMessage}</div>
                        </FormGroup>
                        </div>
                    </div>
                )
            }
        }

        const renderSearchByNumero = () => {
            if(this.state.isSearchByNumero){
                return (
                    <div className="row">
                        <div className="col-md-12">
                        <label htmlFor="valor">Pesquisa pela NF de Número:</label>
                        <input
                            style={{marginLeft: '0.5rem'}}
                            type="text"
                            name="numeroNFToSearch"
                            inputId="numeroNFToSearch"
                            autoFocus
                            value={this.state.numeroNFToSearch}
                            disabled
                        />
                        </div>
                        <br />
                    </div>                    
                )
            }
        }


        return(
            <div className="bs-docs-section" >
                <Card
                    title = "Conferência de NFs de Serviço"
                    rightComponent={renderPesquisaPorNumeroButton()}
                >

                    <div className = "col-md-12">

                        {renderDefaultHeaderFilter()}
                        {renderSearchByNumero()}

                        {renderButtons()}

                        <br />

                        {renderTable()}

                    </div>

                    {renderPesquisaNumeroDialog()}                    

                </Card>
                <div className="d-flex "/>
            </div>                
        )
    }


}

ConferenciaNfse.contextType = AuthContext

export default withRouter(ConferenciaNfse)